import IComponent from "components/commons/IComponent";
import "./PopupMapSheetSelection.scoped.css";
import hkmapIMG from "./hkmapcapture.PNG";
import {
  Button,
  Chip,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";

let sheet16Arr = [
  { subBlock: ["1NW", "1NE", "1SW", "1SE"] },
  { subBlock: ["2NW", "2NE", "2SW", "2SE"] },
  { subBlock: ["3NW", "3NE", "3SW", "3SE"] },
  { subBlock: ["4NW", "4NE", "4SW", "4SE"] },
  { subBlock: ["5NW", "5NE", "5SW", "5SE"] },
  { subBlock: ["6NW", "6NE", "6SW", "6SE"] },
  { subBlock: ["7NW", "7NE", "7SW", "7SE"] },
  { subBlock: ["8NW", "8NE", "8SW", "8SE"] },
  { subBlock: ["9NW", "9NE", "9SW", "9SE"] },
  { subBlock: ["10NW", "10NE", "10SW", "10SE"] },
  { subBlock: ["11NW", "11NE", "11SW", "11SE"] },
  { subBlock: ["12NW", "12NE", "12SW", "12SE"] },
  { subBlock: ["13NW", "13NE", "13SW", "13SE"] },
  { subBlock: ["14NW", "14NE", "14SW", "14SE"] },
  { subBlock: ["15NW", "15NE", "15SW", "15SE"] },
  { subBlock: ["16NW", "16NE", "16SW", "16SE"] },
];

let mapCellWithData = undefined;

class PopupMapSheetSelection extends IComponent {
  constructor(props) {
    super(props);
    let selectedSubBlocks = props.selectedBlock
      ? props.selectedBlock.concat([])
      : [];
    this.state = {
      currentClickedSubBlock: null,
      selectedSubBlocks: selectedSubBlocks,
    };
    this.state.currentSelectedCount = this.state.selectedSubBlocks.length;

    if (typeof mapCellWithData === "undefined")
      mapCellWithData = Array.from(
        new Set(
          Object.values(this.$config.mapList.layer3D)
            .flat()
            .map((i) => i.mapSheetNos)
            .flat()
        )
      );
  }
  componentDidMount() {}
  componentWillUnmount() {}

  handleOnclickSubBlock(subBlockName) {
    if (this.state.selectedSubBlocks.includes(subBlockName)) {
      //TODO: other trigger to cancel selection
      this.cancelSelection(subBlockName);
    } else {
      if (this.state.currentSelectedCount >= (this.props.maxSelection || 4))
        return;
      let currentSubBlockAlreadyClicked =
        this.state.selectedSubBlocks.indexOf(subBlockName) !== -1;
      if (!currentSubBlockAlreadyClicked) {
        this.updateSubBlocksArr(subBlockName);
      }
    }
  }

  updateSubBlocksArr(subBlockName) {
    this.setState({
      currentClickedSubBlock: subBlockName,
    });
    this.setState(
      {
        currentSelectedCount: this.state.currentSelectedCount + 1,
        selectedSubBlocks: [...this.state.selectedSubBlocks, subBlockName],
      },
      this.onClickItemCallback
    );
  }

  //TODO: callback of click mapsheet item
  onClickItemCallback() {}

  cancelSelection(subBlockItem) {
    this.setState((prevState) => {
      let index = prevState.selectedSubBlocks.indexOf(subBlockItem);
      let tmpArr = prevState.selectedSubBlocks;
      tmpArr.splice(index, 1);

      return {
        selectedSubBlocks: tmpArr,
        currentSelectedCount: prevState.currentSelectedCount - 1,
      };
    }, this.onClickItemCallback);
  }

  createMapSheet() {
    return (
      <div className="mapSheetSelectionContainer">
        <div className="BIMselectionMainImage">
          <img src={hkmapIMG} />
        </div>
        <div className="BIMselectionMain">
          {sheet16Arr.map((mapSheetName) => {
            return (
              <div className="subBlockContainer">
                {mapSheetName.subBlock.map((subBlockName) => {
                  return (
                    <div
                      onClick={() => {
                        this.handleOnclickSubBlock(subBlockName);
                      }}
                      className={`subBlockItem ${
                        this.state.selectedSubBlocks.includes(subBlockName)
                          ? "highlightSubBlockItem"
                          : "subBlockItemNoHighLight"
                      }${
                        mapCellWithData.some((i) => i === subBlockName)
                          ? " HaveData"
                          : ""
                      }`}
                    >
                      <div />
                      {subBlockName}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="MapSheetPopupContainer">
        <div className="pointerEventNone" />
        <div
          className="EqualWidthChildren"
          style={{ width: "74%", borderRadius: "10px" }}
        >
          <div className="MapSheetInfoPanel">
            <div className="ListTitle mapsheetInfoTitle">
              Select on Map Sheet
            </div>
            <div className="mapsheetInfoHints">
              Click the grid to choose the section for search (Multiple Choice)
            </div>
            <hr />
            <div
              className="AlignRight mapsheetInfoResetBtn"
              onClick={() => {
                this.setState({
                  selectedSubBlocks: [],
                  currentSelectedCount: 0,
                });
              }}
            >
              Reset
            </div>
            <div className="mapsheetSelectedChipContainer">
              {this.state.selectedSubBlocks.map((i) => (
                <Chip
                  onDelete={() => {
                    this.cancelSelection(i);
                  }}
                  className="mapsheetSelectedChip"
                  label={i}
                />
              ))}
            </div>
          </div>
          <div style={{ height: "100%" }} className="EqualWidthChildren column">
            {this.createMapSheet()}
            <div className="MapSheetButtonBar EqualWidthChildren">
              <Button
                color="primary"
                variant="outlined"
                onClick={() => this.props.onClose()}
                style={{ background: "var(--buttonColor)" }}
              >
                Close
              </Button>
              <Button
                color="primary"
                variant="contained"
                onClick={() => (
                  this.props.onSelectedSheets(this.state.selectedSubBlocks),
                  this.props.onClose()
                )}
              >
                OK
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PopupMapSheetSelection;
